import Vue from 'vue'
import { otRuleTaps } from '../enmu'
const { $t } = Vue.prototype

// 招聘时段校验
export const timeIntervalRule = [{ required: true, message: $t('221'), trigger: ['blur', 'change'] }]

// settings 下的校验规则
const rules = function () {
  return {
    type_name: [{ required: true, message: $t('1715'), trigger: 'blur' }],
    allow_apply_time_interval_forward: [{ required: true, message: $t('1716'), trigger: 'blur' }],
    allow_apply_time_interval_backward: [{ required: true, message: $t('1716'), trigger: 'blur' }],
    mini_limit: [{ required: true, message: $t('1716'), trigger: 'blur' }],
    max_limit: [{ required: true, message: $t('1716'), trigger: 'blur' }],
    increment_step: [{ required: true, message: $t('1716'), trigger: 'blur' }],
    allow_apply_date_forward: [
      {
        validator: (rule, value, callback) => {
          const ruleKey = rule.field.split('.')[1] // working_day
          const settings = this.form.settings[ruleKey]
          // checkbox 选中的情况下判断值是不是为空
          if (settings.is_allow_apply_date_forward && !settings.allow_apply_date_forward) {
            return callback(new Error(this.$t('1716')))
          }
          callback()
        },
        trigger: 'blur'
      }
    ],
    allow_apply_date_backward: [
      {
        validator: (rule, value, callback) => {
          const ruleKey = rule.field.split('.')[1] // working_day
          const settings = this.form.settings[ruleKey]
          // checkbox 选中的情况下判断值是不是为空
          if (settings.is_allow_apply_date_backward && !settings.allow_apply_date_backward) {
            return callback(new Error(this.$t('1716')))
          }
          callback()
        },
        trigger: 'blur'
      }
    ]
  }
}

// settings 校验规则生成
const formateRules = function () {
  const result = {}
  const rule = rules.call(this)
  otRuleTaps.forEach(item => {
    Object.keys(rule).forEach(key => {
      result[`settings.${item}.${key}`] = rule[key]
    })
  })
  return result
}

export default {
  data() {
    return {
      rules: {
        name: [{ required: true, message: $t('1714'), trigger: 'blur' }],
        selectedFormate: [{ required: true, message: $t('221'), trigger: 'change' }],
        ...formateRules.call(this)
      }
    }
  }
}
